import * as React from "react";
import {Button, icons} from "@vebox/etui-core";


import "./Command.scss";
import {themeDefaultValues} from "../../../../index";

interface CommandProps {
    name: string;
    buttonIconHref: string;
    onClick: () => void;
}

export const Command: React.FC<CommandProps> = (props) => {
    return (
        <div className={"flx-row flx-space-between flx-align-center command"} style={{padding: 10}}>
            <h2>{props.name}</h2>
            <Button
                variant={"strong"}
                onClick={props.onClick}
                shape={"circle"}
                styles={{
                    root: {
                        p: 10,
                        width: themeDefaultValues.buttonWidth,
                        height: themeDefaultValues.buttonHeight
                    }
                }}
            >
                <span className="material-icons-outlined">delete</span>
            </Button>
        </div>
    );
};